// extracted by mini-css-extract-plugin
export default {"codeContentTable":"_code-content-table_codeContentTable__l0YZR"};